import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useUpdateDocumentTypeSetting = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base
        .put(`${config.appUrls.documents}/api/DocumentTypeSetting`, model)
        .then(res => res.data), {
        // The endpoint upserts a single row and returns the merged result, so patch it into the
        // cached list instead of replacing the list itself.
        onSuccess: (result) => {
            queryClient.setQueryData([SettingsQueryKey.DocumentTypeSettings], (old = []) => old.some(x => x.documentType === result.documentType)
                ? old.map(x => (x.documentType === result.documentType ? result : x))
                : [...old, result]);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateDocumentTypeSetting: mutateAsync, isLoading };
};
